/* ====================================================================
   Lunai mobile drawer — accordion groups (Chat 8 P1-12; row-as-toggle
   revision 2026-08-20). The whole parent row is ONE button that expands
   the group's subcategories in place — navigation to the group page
   lives on the panel's last row ("Vsi izdelki skupine"). Behaviour:
   - exclusive: opening a group closes the previously open one, so the
     drawer never grows unboundedly and orientation stays cheap;
   - scroll-compensated: when a group ABOVE the tapped row collapses,
     the scroller shifts by the same delta so the tapped row stays put
     under the finger (no jump, §16 of the owner spec);
   - reset on close: when the drawer closes, every group returns to its
     server-rendered default (data-lunai-open-default = the group that
     holds the current collection), so it never reopens mid-state.
   Listeners delegate from document so an editor section re-render
   (shopify:section:load) cannot orphan them. Deliberately no expand
   animation — `hidden` flips, reduced-motion-safe by construction.
   ==================================================================== */
(function () {
  var TOGGLES = '.lunai-dgroup__toggle, .lunai-mlx__toggle';

  function setOpen(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = !open;
    var group = btn.closest('.lunai-dgroup');
    if (group) group.classList.toggle('is-open', open);
    /* First open of the #mojLunai group un-parks its deferred favourites
       rail (same defer rule as the mega panel: no Section-Rendering
       fetches for shoppers who never open it). 'lunai:fav-rails' asks
       lunai-favorites.js to paint rails only — the full 'lunai:fav'
       event would also rebuild a wishlist-page grid. */
    if (open && panel) {
      var rail = panel.querySelector('[data-fav-rail][data-fav-defer]');
      if (rail) {
        rail.removeAttribute('data-fav-defer');
        document.dispatchEvent(new CustomEvent('lunai:fav-rails'));
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(TOGGLES);
    if (!btn) return;
    var drawer = btn.closest('#menu-drawer');
    if (!drawer) return;
    if (!document.getElementById(btn.getAttribute('aria-controls'))) return;
    var willOpen = btn.getAttribute('aria-expanded') !== 'true';

    var scroller = drawer.querySelector('.menu-drawer__navigation-container');
    var before = btn.getBoundingClientRect().top;

    if (willOpen) {
      drawer.querySelectorAll(TOGGLES).forEach(function (other) {
        if (other !== btn && other.getAttribute('aria-expanded') === 'true') setOpen(other, false);
      });
    }
    setOpen(btn, willOpen);

    if (scroller) {
      var delta = btn.getBoundingClientRect().top - before;
      if (delta) scroller.scrollTop += delta;
    }
  });

  /* Dawn removes [open] ~400ms after the close begins (closeAnimation),
     so this reset runs once the drawer is already invisible. Capture
     phase: 'toggle' does not bubble. */
  document.addEventListener(
    'toggle',
    function (e) {
      var details = e.target;
      if (!details.id || details.id !== 'Details-menu-drawer-container' || details.open) return;
      details.querySelectorAll(TOGGLES).forEach(function (btn) {
        setOpen(btn, btn.hasAttribute('data-lunai-open-default'));
      });
    },
    true
  );
})();

/* ====================================================================
   Lunai mega-menu behaviour (ported from the prototype landing nav).
   - Product/myLunai mega panels: `.is-open` (set here) is the only
     reveal — lunai-nav.css no longer paints them on :hover or
     :focus-within, so a hover-opened panel cannot outlive the pointer
     on touch, and a mouse click that parks focus on the trigger no
     longer keeps the panel painted after the pointer has left. Open on
     pointer hover (mouse/pen — never touch), keyboard focus, or a touch
     tap on the trigger; close with a short intent delay once the
     pointer leaves the trigger + visible card (unless focus sits
     inside that card), on a press outside, Escape (focus back on the
     trigger), focus leaving the group, a panel link being followed, or
     another top-level item opening —
     siblings and a pinned Pišite nam dialog yield, so one panel is
     open at a time.
   - Every mega-group handler delegates from document and reads the nav
     at fire time, registered exactly once behind window.lunaiMegaNav:
     a Theme Editor re-render of the header (shopify:section:load /
     :select) needs no re-wiring and cannot duplicate a listener. Only
     the Pišite nam dialog keeps per-node wiring (focus trap, form),
     re-armed idempotently on those events.
   - Pišite nam: a click dialog (never hover) with focus trap, Esc and
     outside-click to close, and a mailto submit.
   ==================================================================== */
(function () {
  if (window.lunaiMegaNav) return;
  window.lunaiMegaNav = true;

  /* ── Product/myLunai mega panels ── */
  /* keep ≤ 260ms: the split panel's RESET_DELAY (500ms, below) must
     outlast this delay + the 240ms panel fade */
  var CLOSE_DELAY = 200;
  /* a touch tap's focusin (Android) and click follow its pointerup well
     inside this window */
  var TAP_WINDOW = 500;
  var GROUP = '.lunai-mega .has-dropdown:not(.has-dropdown--popover)';

  function navEl() { return document.querySelector('.lunai-mega'); }
  function groupsOf(nav) {
    return Array.prototype.slice.call(nav.querySelectorAll('.has-dropdown:not(.has-dropdown--popover)'));
  }
  function groupOf(el) { return el && el.closest ? el.closest(GROUP) : null; }
  /* The avatar picker (lunai-account.js) is a fixed overlay appended to
     <body> that the #mojLunai panel itself opens — pointer or focus
     moving into it is not leaving the menu. */
  function inOverlay(el) { return !!(el && el.closest && el.closest('.ml-av')); }
  /* Keyboard focus INSIDE the panel outlives the pointer: a stray mouse
     move must not pull the panel — and the shopper's place in it — out
     from under them, which is what the CSS :focus-within reveal used to
     prevent. Focus on the TRIGGER does not count: a click parking it
     there is exactly the case this has to close. Focus leaving the
     group is handled by focusin/focusout below. */
  function focusInPanel(hd) {
    var p = hd.querySelector('.dropdown-panel');
    return !!(p && p.contains(document.activeElement));
  }
  /* The VISIBLE surface of a group: its trigger (the hover bridge is the
     trigger's pseudo-element, so a hit there targets the trigger) and
     the card. The .products-panel box behind the card is a viewport-wide
     invisible band, so a hit on the bare box counts as inside only
     within the card's horizontal span — the padding strip between the
     bridge and the card — never in the band beside the card. */
  function surfaceGroup(el, x) {
    var hd = groupOf(el);
    if (!hd) return null;
    if (!el.closest('.dropdown-panel') || el.closest('.menu-mega-inner')) return hd;
    var card = hd.querySelector('.menu-mega-inner');
    if (!card || typeof x !== 'number') return null;
    var r = card.getBoundingClientRect();
    return x >= r.left && x <= r.right ? hd : null;
  }
  function setExpanded(hd, on) {
    var t = hd.querySelector('.dropdown-trigger');
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
  }
  function cancelClose(hd) { clearTimeout(hd._t); hd._t = null; }
  function scheduleClose(hd) {
    cancelClose(hd);
    hd._t = setTimeout(function () {
      hd._t = null;
      if (focusInPanel(hd)) return;
      closeNow(hd);
    }, CLOSE_DELAY);
  }
  function closeNow(hd) {
    cancelClose(hd);
    hd._byPointer = false;
    hd.classList.remove('is-open');
    setExpanded(hd, false);
  }
  function closeMega(except) {
    var nav = navEl();
    if (!nav) return;
    groupsOf(nav).forEach(function (other) { if (other !== except) closeNow(other); });
  }
  function openNow(hd) {
    cancelClose(hd);
    hd.classList.remove('is-esc-closed');
    closeMega(hd);
    /* one panel at a time: a pinned Pišite nam dialog yields (quiet
       close — no focus return, see wirePopover) */
    var nav = hd.closest('.lunai-mega');
    var pop = nav && nav.querySelector('.has-dropdown--popover.is-open');
    if (pop && pop._lunaiClose) pop._lunaiClose();
    hd.classList.add('is-open');
    setExpanded(hd, true);
  }
  function recentTap(hd) { return !!hd._tap && Date.now() - hd._tap < TAP_WINDOW; }

  /* Hover (mouse/pen — touch never hover-opens). Over a group's surface:
     open, or cancel its pending close. Anywhere else — page content,
     the band beside the card: a panel the POINTER opened closes after
     the intent delay, unless its card holds focus (a keyboard-opened
     one ignores stray mouse movement outright); both then close on
     focusout / outside press / Escape instead;
     crossing onto Pišite nam, whose dialog reveals on CSS :hover,
     swaps at once like a sibling trigger does. */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var nav = navEl();
    if (!nav) return;
    var hd = surfaceGroup(e.target, e.clientX);
    if (hd) {
      if (hd.classList.contains('is-open')) cancelClose(hd); else openNow(hd);
      hd._byPointer = true;
      return;
    }
    if (inOverlay(e.target)) return;
    var swap = !!(e.target.closest && e.target.closest('.has-dropdown--popover'));
    groupsOf(nav).forEach(function (g) {
      if (!g.classList.contains('is-open')) return;
      if (swap) closeNow(g);
      else if (g._byPointer && !g._t) scheduleClose(g);
    });
  });
  /* the pointer leaving the window: no pointerover will follow */
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'touch' || e.relatedTarget) return;
    var hd = groupOf(e.target);
    if (hd && hd.classList.contains('is-open') && hd._byPointer && !hd._t) scheduleClose(hd);
  });

  /* Press outside — pointerdown, not click: it runs before focus moves,
     and iOS taps on non-clickable page content dispatch no mouse events
     at all. The scrim is pointer-events:none, so page targets are real;
     the header's own icons and the Pišite nam item count as outside. */
  document.addEventListener('pointerdown', function (e) {
    if (surfaceGroup(e.target, e.clientX) || inOverlay(e.target)) return;
    closeMega();
  });
  /* Touch: a tap on a trigger toggles — on pointerup rather than click,
     which iOS withholds when a compat mouseenter handler (the #mojLunai
     favourites-rail un-defer in lunai-favorites.js) mutates content
     first. The tap's own focusin (Android) and click are then ignored. */
  document.addEventListener('pointerup', function (e) {
    if (e.pointerType !== 'touch') return;
    var hd = groupOf(e.target.closest && e.target.closest('.dropdown-trigger'));
    if (!hd) return;
    hd._tap = Date.now();
    if (hd.classList.contains('is-open')) closeNow(hd); else openNow(hd);
  });

  /* Focus landing in a group opens it (keyboard users); landing anywhere
     else closes an open group (tabbing past the nav, the Pišite nam
     dialog taking focus) and lifts the Esc suppressions. */
  document.addEventListener('focusin', function (e) {
    var nav = navEl();
    if (!nav || inOverlay(e.target)) return;
    var hd = groupOf(e.target);
    groupsOf(nav).forEach(function (g) {
      if (g === hd) return;
      if (g.classList.contains('is-open')) closeNow(g);
      g.classList.remove('is-esc-closed');
    });
    var pop = nav.querySelector('.has-dropdown--popover');
    if (pop && !pop.contains(e.target)) pop.classList.remove('is-esc-closed');
    if (!hd) return;
    /* after an Esc close the trigger regains focus — don't reopen; a
       touch tap's focus was handled on pointerup */
    if (hd.classList.contains('is-esc-closed') || recentTap(hd)) return;
    openNow(hd);
  });
  /* Focus dropping to <body> — a click on non-focusable content, or the
     window losing focus (alt-tab, the avatar picker's OS file dialog):
     no focusin follows. Decide once focus has settled: the window case
     keeps activeElement inside the group and a click inside the card
     keeps the pointer on it — both stay open; anything else closes.
     Focus moving to another element is handled by focusin above. */
  document.addEventListener('focusout', function (e) {
    if (e.relatedTarget) return;
    var hd = groupOf(e.target);
    if (!hd || !hd.classList.contains('is-open')) return;
    setTimeout(function () {
      if (hd.contains(document.activeElement) || hd.matches(':hover')) return;
      closeNow(hd);
    }, 0);
  });

  /* Escape — bubble phase on purpose: lunai-account.js stops Escape in
     the capture phase while the avatar picker is open, so it never
     reaches here and the #mojLunai panel stays put under the picker. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var hd = groupOf(e.target);
    /* a hover-opened panel with focus elsewhere: close, leave focus be */
    if (!hd) { closeMega(); return; }
    /* focus may sit on a link INSIDE the panel; return it to the
       trigger and suppress the focusin reopen until focus leaves the
       group (menu-button pattern) */
    hd.classList.add('is-esc-closed');
    closeNow(hd);
    var b = hd.querySelector('.dropdown-trigger');
    if (b) b.focus();
  });

  document.addEventListener('click', function (e) {
    var hd = groupOf(e.target);
    if (!hd) return;
    if (e.target.closest('.dropdown-trigger')) {
      /* Enter/Space (or a mouse click) on a CLOSED trigger opens it —
         e.g. straight after Escape; a touch tap already toggled on
         pointerup. An open panel is never toggled shut here: hover
         opens it first, so a click would look like a broken open. */
      if (!hd.classList.contains('is-open') && !recentTap(hd)) openNow(hd);
      return;
    }
    /* a panel link being followed: close at once so the panel is not
       still painted while the page navigates (never preventDefault).
       A ⌘/Ctrl/Shift/middle click opens a background tab or window and
       leaves this page put, so the panel stays open for the next pick. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (e.target.closest('a[href]')) closeNow(hd);
  });

  /* ── Pišite nam — contact popover dialog ── */
  function wirePopover() {
    var nav = navEl();
    var wrap = nav && nav.querySelector('.has-dropdown--popover');
    if (!wrap || wrap._lunaiWired) return;
    wrap._lunaiWired = true;
    var trigger = wrap.querySelector('[data-contact-trigger]');
    var dialog = wrap.querySelector('[data-contact-dialog]');
    if (!trigger || !dialog) return;
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function focusables() { return Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE)).filter(function (el) { return el.offsetParent !== null; }); }
    function isOpen() { return wrap.classList.contains('is-open'); }
    function onKeydown(e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function onDocClick(e) { if (!wrap.contains(e.target)) close(); }
    function open() {
      if (isOpen()) return;
      wrap.classList.remove('is-esc-closed');
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      var f = focusables(); if (f.length) f[0].focus();
      dialog.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onDocClick);
    }
    function close(quiet) {
      if (!isOpen()) return;
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      dialog.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onDocClick);
      /* Yielding to a mega panel (openNow above): NO focus return — it
         would land in this li and the delegated focusin would close the
         panel that just opened. Focus parked in the form drops to
         <body> instead (as for any pointer user), so :focus-within
         cannot show the dialog again once mouseleave lifts the
         suppression below. */
      if (quiet) {
        if (wrap.contains(document.activeElement)) document.activeElement.blur();
        return;
      }
      /* Same trap as the mega groups: focus returns to the trigger, which
         sits inside the li, so the CSS :focus-within / :hover reveal
         showed the dialog again with aria-expanded="false" (Escape and
         the toggle click looked broken). The !important suppression in
         lunai-nav.css hides it until focus leaves the li or the pointer
         leaves and comes back — hover-open keeps working after that. */
      wrap.classList.add('is-esc-closed');
      trigger.focus();
    }
    wrap.addEventListener('mouseleave', function () { wrap.classList.remove('is-esc-closed'); });
    /* (focus leaving the li lifts is-esc-closed in the delegated focusin
       handler above — once per document, never per wrap) */
    trigger.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); isOpen() ? close() : open(); });
    trigger.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });
    /* the mega groups close a pinned dialog when they open (one panel at a time) */
    wrap._lunaiClose = function () { close(true); };

    /* The form POSTs to /contact and Shopify redirects back to this page
       with the #ContactNavPopover anchor — a closed popover would swallow
       the success/error status Liquid just rendered, so reopen it. Both
       gates matter: the status node also renders if some OTHER contact
       form on the page posted, and the anchor alone survives manual URL
       edits with nothing to show. */
    if (window.location.hash === '#ContactNavPopover' && dialog.querySelector('[data-contact-posted]')) {
      open();
    }
  }
  wirePopover();
  /* The Theme Editor re-renders the header without re-running this
     script: the delegated handlers above need nothing, and the dialog's
     per-node wiring re-arms on the fresh li — guarded by _lunaiWired and
     adding no document listener, so nothing can ever duplicate. */
  document.addEventListener('shopify:section:load', wirePopover);
  document.addEventListener('shopify:section:select', wirePopover);
})();

/* ====================================================================
   Za vsak trenutek — split-panel preview swap (owner design option 1b,
   2026-08-30). The list links are the interactive surface: hovering or
   focusing one crossfades the stage to its pane and moves the chip
   highlight with it. The stage is decorative for keyboard/AT users
   (aria-hidden container, tabindex -1 panes) — it only duplicates the
   active link for mouse users, so no swap ever changes the tab order.
   Everything delegates from document (mouseout/focusout bubble, unlike
   mouseleave) and the default handle is read from data-msplit-default
   at fire time, so an editor section re-render cannot orphan any of it.
   ==================================================================== */
(function () {
  /* outlasts the panel's 200ms close delay + 240ms fade, so the shopper
     never sees the crossfade back to the default */
  var RESET_DELAY = 500;

  function activate(root, handle) {
    root.querySelectorAll('[data-msplit-item]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-msplit-item') === handle);
    });
    root.querySelectorAll('[data-msplit-pane]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-msplit-pane') === handle);
    });
  }

  function rootOf(el) {
    var group = el && el.closest ? el.closest('.has-dropdown') : null;
    return group ? group.querySelector('[data-msplit]') : null;
  }

  function cancelReset(root) {
    if (root._msplitReset) { clearTimeout(root._msplitReset); root._msplitReset = null; }
  }

  /* pointer or focus entering the group: cancel a pending reset, and a
     list item under it swaps the stage */
  function onEnter(e) {
    var root = rootOf(e.target);
    if (!root) return;
    cancelReset(root);
    var item = e.target.closest('[data-msplit-item]');
    if (item) activate(root, item.getAttribute('data-msplit-item'));
  }
  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);

  /* pointer or focus leaving the group entirely: restore the
     server-marked default pane (the current collection, else the first
     moment), so a stale hover never outlives the visit. Re-checked at
     fire time — hover, focus (Esc parks focus on the trigger) and the
     default handle all read live, never from a stale closure. */
  function onLeave(e) {
    var root = rootOf(e.target);
    if (!root) return;
    var group = e.target.closest('.has-dropdown');
    if (e.relatedTarget && group.contains(e.relatedTarget)) return;
    cancelReset(root);
    root._msplitReset = setTimeout(function () {
      root._msplitReset = null;
      if (group.matches(':hover') || group.contains(document.activeElement)) return;
      var def = root.getAttribute('data-msplit-default');
      if (def) activate(root, def);
    }, RESET_DELAY);
  }
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('focusout', onLeave);
})();
